import script from "./Bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./Bottom.vue?vue&type=script&setup=true&lang=js"

import "./Bottom.vue?vue&type=style&index=0&id=c96e13e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c96e13e6"]])

export default __exports__